export default class ListaResultadoService {
    $q;
    CoreListaRelatorioResultado;
    CoreDepartamento;
    constructor($q, CoreListaRelatorioResultado, CoreDepartamento) {
        this.$q = $q;
        this.CoreListaRelatorioResultado = CoreListaRelatorioResultado;
        this.CoreDepartamento = CoreDepartamento;
    }
    findAll(query) {
        return this.CoreListaRelatorioResultado.table(query).$promise;
    }
    findOne(id) {
        return this.CoreListaRelatorioResultado.findOne({
            filter: {
                where: {
                    id
                }
            }
        }).$promise;
    }
    options() {
        return this.CoreListaRelatorioResultado.options().$promise;
    }
    patch(id, data) {
        return this.CoreListaRelatorioResultado.patch({ id }, data).$promise;
    }
    departamentos() {
        // FIXME: CoreDepartamento tem que ser ligado ao utilizador (fazer vista? Falar com o FM)
        return this.CoreDepartamento.find({
            filter: {
                where: {
                    active: true
                }
            }
        }).$promise;
    }
    create(data) {
        return this.CoreListaRelatorioResultado.create(data).$promise;
    }
}
ListaResultadoService.$inject = ['$q', 'CoreListaRelatorioResultado', 'CoreDepartamento'];
